import { render, staticRenderFns } from "./39.vue?vue&type=template&id=f0bf36b8&scoped=true&"
import script from "./39.vue?vue&type=script&lang=js&"
export * from "./39.vue?vue&type=script&lang=js&"
import style0 from "./39.vue?vue&type=style&index=0&id=f0bf36b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bf36b8",
  null
  
)

export default component.exports